import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ViewModelProperty } from '../../models';

@Component({
  selector: 'ldw-vmp-label',
  templateUrl: './vmp-label.component.html',
  styleUrls: ['./vmp-label.component.css'],
  imports: [TranslatePipe]
})
export class VMPLabelComponent {
  vmp = input<ViewModelProperty>();

  get caption(): string {
    const vmp = this.vmp();
    if (vmp === undefined || vmp.caption === undefined) {
      return '';
    }
    return vmp.caption;
  }
}
